import React from 'react';
import { ReceiptIcon, MessageCircleIcon, ClockIcon, UserIcon, HomeIcon } from 'lucide-react';
export function Layout({
  children,
  currentScreen,
  navigateTo
}) {
  return <div className="flex flex-col h-screen bg-gray-50" data-id="element-38">
      <div className="flex-1 overflow-y-auto pb-28" data-id="element-39">{children}</div>
      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 z-40" data-id="element-40">
        <div className="flex justify-around items-center py-2" data-id="element-41">
          <button onClick={() => navigateTo('home')} className={`flex flex-col items-center p-2 ${currentScreen === 'home' ? 'text-blue-600' : 'text-gray-500'}`} aria-label="Home" data-id="element-42">
            <HomeIcon size={20} data-id="element-43" />
            <span className="text-xs mt-1" data-id="element-44">Home</span>
          </button>
          <button onClick={() => navigateTo('upload')} className={`flex flex-col items-center p-2 ${currentScreen === 'upload' ? 'text-blue-600' : 'text-gray-500'}`} aria-label="Upload Receipt" data-id="element-45">
            <ReceiptIcon size={20} data-id="element-46" />
            <span className="text-xs mt-1" data-id="element-47">Upload</span>
          </button>
          <button onClick={() => window.open('https://spaces.sprinklenet.com/chat?id=6872b2c60d4052fb0ee93307', '_blank', 'noopener,noreferrer')} className="flex flex-col items-center p-2 text-gray-500" aria-label="Assistant" data-id="element-48">
            <MessageCircleIcon size={20} data-id="element-49" />
            <span className="text-xs mt-1" data-id="element-50">Assistant</span>
          </button>
          <button onClick={() => navigateTo('history')} className={`flex flex-col items-center p-2 ${currentScreen === 'history' ? 'text-blue-600' : 'text-gray-500'}`} aria-label="History" data-id="element-51">
            <ClockIcon size={20} data-id="element-52" />
            <span className="text-xs mt-1" data-id="element-53">History</span>
          </button>
          <button onClick={() => navigateTo('settings')} className={`flex flex-col items-center p-2 ${currentScreen === 'settings' ? 'text-blue-600' : 'text-gray-500'}`} aria-label="Settings" data-id="element-54">
            <UserIcon size={20} data-id="element-55" />
            <span className="text-xs mt-1" data-id="element-56">Settings</span>
          </button>
        </div>
        <div className="flex justify-center items-center py-1.5 bg-blue-900" data-id="element-57">
          <span className="text-xs text-gray-300 mr-1" data-id="element-58">Powered by</span>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9ocnKpiy3Tz6Lcxp86o86F/Sprinklenet_Logo_White.png" alt="Sprinklenet" className="h-4" data-id="element-59" />
        </div>
      </nav>
    </div>;
}